import { useState, useEffect, useCallback } from 'react'

/**
 * Manages edit/view mode for detail pages.
 * - Escape key always exits edit mode (unless isNew).
 * - Pass isNew=true to start in edit mode and disable Escape.
 */
export function useEditMode(isNew: boolean) {
  const [isEditing, setIsEditing] = useState(isNew)

  const startEditing = useCallback(() => setIsEditing(true), [])
  const stopEditing = useCallback(() => setIsEditing(false), [])

  useEffect(() => {
    if (isNew) return
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isEditing) {
        setIsEditing(false)
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [isNew, isEditing])

  return { isEditing, startEditing, stopEditing }
}
